import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getVariation, getFlavor, ADDONS } from "@/data/products";

const CartCtx = createContext(null);
const KEY = "sweetjuice_cart_v2";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v.filter((i) => i && i.product_id && Array.isArray(i.addons)) : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product_id, addons = [], qty = 1) => {
    const key = [product_id, [...addons].sort().join(",")].join("|");
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { key, product_id, addons, qty }];
    });
  };
  const setQty = (key, qty) =>
    setItems((prev) => (qty <= 0 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, qty } : i))));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const lines = items
      .map((i) => {
        const p = getVariation(i.product_id) ?? getFlavor(i.product_id);
        if (!p) return null;
        const addonSum = i.addons.reduce((s, a) => s + (ADDONS.find((x) => x.id === a)?.price ?? 0), 0);
        const unit = Math.round((p.price + addonSum) * 100) / 100;
        const addonLabels = i.addons.map((a) => ADDONS.find((x) => x.id === a)?.label.replace("Add in ", "")).filter(Boolean);
        return { ...i, product: p, unit, addonLabels, total: unit * i.qty };
      })
      .filter(Boolean);
    const subtotal = lines.reduce((s, l) => s + l.total, 0);
    const count = lines.reduce((s, l) => s + l.qty, 0);
    return { items, lines, subtotal, count, add, setQty, clear, open, setOpen };
  }, [items, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
